module.exports = __webpack_public_path__ + "img/app-logo.0ad2d237.png";